import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Search from "./Search";
import BtnLoad from "./BtnLoad";
import CheckBox from "./CheckBox";
import SimAccordion from "./Accordion";
import { CheckNormalIcon, CloseIcon, BackIcon } from "../assets/Icons";
import axios from "axios";
import { jwt, SERVER_IP, UNO_URL } from "../Server";
import UserGroupListSkelton from "./UserGroupListSkelton";

const ShareModal = ({ show, onClose, subGroups = [], userDetails, selectedWorkflow, headingName }) => {
  const [activeTab, setActiveTab] = useState("user");
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [checkedGroups, setCheckedGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [assignedLoading, setAssignedLoading] = useState(true);
  const [accesList, setAccessList] = useState(true);
  const [userPermissions, setUserPermissions] = useState({});
  const [users, setUsers] = useState([]);
  const [userLoading, setUserLoading] = useState(true);
  const [assignedWorkFlows, setAssignedWorkFlows] = useState([]);
  const [access, setAccess] = useState("view");

  const getInitials = (name) =>
    name
      ?.split(" ")
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join("");

  const handleCancelModal = () => {
    setSearch("");
    setAssignedWorkFlows([]);
    setActiveTab("user");
    setCheckedUsers([]);
    setCheckedGroups([]);
    setUserPermissions({});
    onClose(true);
    setAccessList(true);
  };

  const addMore = () => {
    setAccessList((prev) => !prev);
  };

  const handlePermissionChange = (id, permission, isUser = true) => {
    const obj = {
      userId: isUser ? id : null,
      groupId: isUser ? null : id,
      type: permission,
    };

    setAssignedWorkFlows((prev) =>
      prev.map((e) => {
        if (e?.user?.uuid === id || e?.group?.uuid === id) {
          return { ...e, type: permission };
        }
        return e;
      })
    );

    setUserPermissions((prev) => ({
      ...prev,
      [id]: obj,
    }));
  };

  const fetchGroupUsers = async () => {
    try {
      setUserLoading(true);
      const groupId = userDetails?.user?.group?.uuid;
      const token = userDetails?.token;
      const res = await axios.get(`${UNO_URL}/api/group/all/children/users/${groupId}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: 25, page: 1, search },
      });
      setUsers(res?.data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setUserLoading(false);
    }
  };

  const fetchAssignedWorkFlows = async () => {
    try {
      setAssignedLoading(true);
      const unoToken = localStorage.getItem("unoToken");
      const headers = { jwt_token: jwt, unoToken };
      const res = await axios.post(
        `${SERVER_IP}/workflow/get/share`,
        {
          workflowId: selectedWorkflow?.id,
          user_UUID: userDetails?.user?.uuid,
          group_UUID: userDetails?.user?.group?.uuid,
        },
        { withCredentials: true, headers }
      );

      setAssignedWorkFlows(res?.data?.result?.workflows);
      setAccess(res?.data?.result?.access);
    } catch (error) {
      console.log(error);
    } finally {
      setAssignedLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      if (access == "view") return;
      setLoading(true);
      const headers = { jwt_token: jwt };
      const alreadyAssignedGroups = assignedWorkFlows?.filter((e) => e.group)?.map((e) => e.group?.uuid) || [];
      const filteredNewGroups = checkedGroups?.filter((uuid) => !alreadyAssignedGroups.includes(uuid));
      await axios.post(
        `${SERVER_IP}/workflow/w/share`,
        {
          workflowId: selectedWorkflow?.id,
          type: "view",
          users: checkedUsers,
          groups: filteredNewGroups,
          changedPermissions: Object.values(userPermissions),
        },
        { withCredentials: true, headers }
      );
    } catch (error) {
      console.log(error);
    } finally {
      handleCancelModal();
      setLoading(false);
    }
  };

  const filterAssignedUsers = (users = []) => {
    const assignedUsers = assignedWorkFlows?.filter((e) => e.user)?.map((e) => e.user?.uuid) || [];
    return users.filter((user) => !assignedUsers?.includes(user.uuid));
  };

  const init = async () => {
    await fetchAssignedWorkFlows();
    fetchGroupUsers();
  };

  useEffect(() => {
    if (show) {
      setActiveTab("user");
      setSearch("");
      init();
    }
  }, [show]);

  useEffect(() => {
    if(userDetails?.token){
      fetchGroupUsers();
    }
  }, [search, ]);

  return (
    <Modal show={show} onHide={onClose} centered backdrop={true} keyboard={true}  className="sim-body-modal" >
      <Modal.Header className="sim-modal-header">
        <Modal.Title className="title">
          {!accesList && (
            <span onClick={addMore} className="pr-2 cursor-pointer">
              <BackIcon />
            </span>
          )}
          {`Share ${headingName || 'Workflow' }`}
        </Modal.Title>
        <button onClick={handleCancelModal} className="close-s schedule-modal-button" type="button" title="Close">
          <CloseIcon />
        </button>
      </Modal.Header>

      <Modal.Body className="sim-body-modal">
        <div className="assignmodal">
          <div className="searchwithborder seacrh-padding share-search">
            <Search placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>

          {accesList ? (
            <>
              <div className="groupusertab">
                <h6 className="mb-3">Who has access</h6>
                <div className="groupusercont">
                  {assignedLoading ? (
                    <UserGroupListSkelton number={5} />
                  ) : (
                    <div className="user-tab-content">
                      {assignedWorkFlows
                        ?.filter((entry) => {
                          const searchValue = search.toLowerCase();
                          return (
                            entry?.user?.name?.toLowerCase()?.includes(searchValue) ||
                            entry?.group?.name?.toLowerCase()?.includes(searchValue)
                          );
                        })
                        ?.map((entry) => {
                          const isUser = !!entry.user;
                          const avatar = isUser ? entry.user.avatar : entry.group.avatar;
                          const name = isUser ? entry.user.name : entry.group.name;
                          const email = isUser ? entry.user.email : "";
                          const uuid = isUser ? entry.user.uuid : entry.group.uuid;

                          return (
                            <div key={entry.id} className="d-flex align-items-center gap-2 mb-2">
                              <div className="d-flex align-items-center gap-1 w-100">
                                {avatar ? (
                                  <img
                                    src={avatar}
                                    alt={name}
                                    className="rounded-circle"
                                    style={{ width: 30, height: 30, objectFit: "cover", objectPosition: "top" }}
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                                    style={{ width: 30, height: 30 }}
                                  >
                                    {getInitials(name)}
                                  </div>
                                )}
                                <div className="d-flex justify-content-between w-100 pr-2">
                                  <div className={`${entry.type === "remove" ? "marked-for-removal" : ""}`}>
                                    <p className="mb-0">{name}</p>
                                    {!!email && <p className="mb-0 text-muted small">{email}</p>}
                                  </div>
                                  <div className="dropdown permissionbtn">
                                    <span
                                      className={
                                        entry.type == "owner" || access == "view" ? "disable" : "dropdown-toggle"
                                      }
                                      type="button"
                                      data-toggle={entry.type == "owner" || access == "view" ? "" : "dropdown"}
                                      aria-expanded={entry.type == "owner" || access == "view" ? "" : "false"}
                                    >
                                      {entry.type}
                                    </span>
                                    <div className="dropdown-menu text-left ">
                                      {["view", "edit", "remove"].map((perm) => (
                                        <a
                                          key={perm}
                                          className="dropdown-item"
                                          href="#!"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handlePermissionChange(uuid, perm, isUser);
                                          }}
                                        >
                                          <span className="check">{entry.type === perm && <CheckNormalIcon />}</span>{" "}
                                          {perm}
                                        </a>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer p-0 pb-0 w-100 mt-3">
                <div className="modal-footer-btns justify-content-between gap-2 w-100">
                  <button disabled={access === "view"} onClick={addMore} className="btn btn-link">
                    Add More
                  </button>
                  <button disabled={access === "view"} onClick={handleSave} className="save">
                    {loading ? <BtnLoad /> : "Save"}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="groupusertab">
                <ul className="nav-tabs">
                  <li className={activeTab === "user" ? "active" : ""} onClick={() => setActiveTab("user")}>
                    User
                  </li>
                  <li className={activeTab === "group" ? "active" : ""} onClick={() => setActiveTab("group")}>
                    Group
                  </li>
                </ul>

                <div className="groupusercont">
                  {activeTab === "user" ? (
                    userLoading ? (
                      <UserGroupListSkelton number={5} />
                    ) : (
                      <div className="user-tab-content">
                        {filterAssignedUsers(users)
                          .filter(
                            (user) =>
                              user?.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
                              user?.email?.toLowerCase()?.includes(search?.toLowerCase())
                          )
                          .map((user) => (
                            <div key={user.uuid} className="d-flex align-items-center gap-2 mb-2">
                              <CheckBox
                                id={user.uuid}
                                checked={checkedUsers.includes(user.uuid)}
                                onChange={() =>
                                  setCheckedUsers((prev) =>
                                    prev.includes(user.uuid)
                                      ? prev.filter((id) => id !== user.uuid)
                                      : [...prev, user.uuid]
                                  )
                                }
                              />
                              <div className="d-flex align-items-center gap-1">
                                {user.avatar ? (
                                  <img
                                    src={user.avatar}
                                    alt={user.name}
                                    className="rounded-circle"
                                    style={{ width: 30, height: 30, objectFit: "cover", objectPosition: "top" }}
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                                    style={{ width: 30, height: 30 }}
                                  >
                                    {getInitials(user.name)}
                                  </div>
                                )}
                                <div>
                                  <p className="mb-0 font-weight-bold">{user.name}</p>
                                  <p className="mb-0 text-muted small">{user.email}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    )
                  ) : search ? (
                    subGroups?.subGroupsDataList
                      ?.filter((group) => !assignedWorkFlows.find((e) => e.group?.uuid === group.uuid))
                      .filter((g) => g.name?.toLowerCase()?.includes(search.toLowerCase()))
                      .map((g) => (
                        <div key={g.uuid} className="d-flex align-items-center gap-2 mb-2">
                          <CheckBox
                            id={g.uuid}
                            checked={checkedGroups.includes(g.uuid)}
                            onChange={() =>
                              setCheckedGroups((prev) =>
                                prev.includes(g.uuid) ? prev.filter((id) => id !== g.uuid) : [...prev, g.uuid]
                              )
                            }
                          />
                          <div>{getInitials(g.name)}</div>
                          <div>{g.name}</div>
                        </div>
                      ))
                  ) : (
                    <div className="group-tab-content">
                      <SimAccordion
                        items={subGroups?.subGroupsDataHierarchy}
                        setterFunc={setCheckedGroups}
                        selected={checkedGroups}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer justify-content-end p-0 pb-0">
                <div className="modal-footer-btns gap-2">
                  <button onClick={handleCancelModal} className="cancel">
                    Cancel
                  </button>
                  <button onClick={handleSave} className="save">
                    {loading ? <BtnLoad /> : "Save"}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
